export const SALE_DEPOSIT_LIST_REQUEST = "SALE_DEPOSIT_LIST_REQUEST";
export const SALE_DEPOSIT_LIST_SUCCESS = "SALE_DEPOSIT_LIST_REQUEST_SUCCESS";

export {
  READ_SALE_ORDER,
  PRINT_SALE_ORDER,
  VIEW_ALL_SALE_ORDER,
  VIEW_SALE_TEAM_SALE_ORDER,
} from "@sale/sale-center/sale-order/constants";
